import React from 'react';
import { AboutSection } from '../components/AboutSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { CTABanner } from '../components/CTABanner';
export function AboutPage() {
  return <main data-id="element-208">
      {/* Hero Banner */}
      <section className="bg-slate-900 py-20 text-center px-4" data-id="element-209">
        <div className="container mx-auto max-w-3xl" data-id="element-210">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-211">
            About Us
          </h1>
          <p className="text-xl text-slate-300" data-id="element-212">
            Your trusted partner in emergency delivery and logistics across the
            United Kingdom.
          </p>
        </div>
      </section>

      <AboutSection data-id="element-213" />
      <WhyChooseUs data-id="element-214" />

      {/* Mission & Values */}
      <section className="py-20 bg-white" data-id="element-215">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-216">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-217">
            <div data-id="element-218">
              <h2 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-219">
                Our Mission
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-220">
                To provide unparalleled emergency delivery and logistics
                solutions across the UK, ensuring that every parcel, piece of
                furniture, and relocation is handled with the utmost care,
                speed, and professionalism. We strive to be the most reliable
                logistics partner for businesses and individuals alike.
              </p>
            </div>
            <div data-id="element-221">
              <h2 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-222">
                Our Values
              </h2>
              <ul className="space-y-4 text-slate-600" data-id="element-223">
                <li data-id="element-224">
                  <strong className="text-slate-900" data-id="element-225">Reliability:</strong> We
                  deliver on our promises, every time.
                </li>
                <li data-id="element-226">
                  <strong className="text-slate-900" data-id="element-227">Speed:</strong> Rapid
                  response times for emergency needs.
                </li>
                <li data-id="element-228">
                  <strong className="text-slate-900" data-id="element-229">Professionalism:</strong>{' '}
                  Vetted, experienced drivers and staff.
                </li>
                <li data-id="element-230">
                  <strong className="text-slate-900" data-id="element-231">Care:</strong> Treating
                  your items as if they were our own.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <CTABanner data-id="element-232" />
    </main>;
}